import React from 'react';
import { useI18n } from '../context/I18nContext';
import { formatAuthError } from '../utils/formatAuthError';
import './AuthAlert.css';

export function AuthAlert({ error }) {
  const { t } = useI18n();
  if (!error) return null;

  const errorMessage = formatAuthError(error, t);

  return (
    <div className="auth-alert" role="alert">
      <svg
        className="auth-alert__icon"
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
          clipRule="evenodd"
        />
      </svg>
      <div className="auth-alert__content">
        <p className="auth-alert__title">{t('auth.errors.title')}</p>
        <p className="auth-alert__message">{errorMessage}</p>
      </div>
    </div>
  );
}
